/**
 * Landing — FXC-8680.
 *
 * The two-page entry (Landing → SignIn) has been collapsed into a single
 * SignIn page. Landing now simply redirects to SignIn so that any stale
 * bookmark or in-app link that still navigates to "/" in the unauthenticated
 * routes block reaches the consolidated entry without a flash of the old
 * two-step surface.
 *
 * App.tsx's unauthenticated catch-all renders <SignIn /> directly; the
 * explicit <Route path="/" element={<Landing />} /> in the unauthenticated
 * block picks up here and immediately hands off.
 */

import { Navigate } from "react-router-dom";

export default function Landing() {
  return <Navigate to="/sign-in" replace />;
}
